import { useRef } from "react";
import DonationCallout from "../components/DonationCallout";

const MeditationPage = () => {
  const sessionRef = useRef(null);

  const handleScrollToSession = () => {
    sessionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="bg-white py-16 px-4 sm:px-6 lg:px-20">
      {/* Intro Section */}
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10">
        {/* Image */}
        <div data-aos="fade-right" className="w-full lg:w-1/2">
          <img
            src="/Website-Photos-7.png"
            alt="Sahaja Yoga Meditation"
            className="w-full h-auto rounded-xl shadow-md border border-green-100"
          />
        </div>

        {/* Text */}
        <div data-aos="fade-left" className="w-full lg:w-1/2">
          <h2 className="text-sm text-green-700 font-semibold uppercase mb-2 tracking-wide text-center lg:text-left">
            Experience Inner Silence
          </h2>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-snug text-center lg:text-left">
            What is Sahaja Yoga Meditation?
          </h1>
          <p className="text-gray-700 leading-relaxed mb-4 text-left">
            Sahaja Yoga is a unique method of meditation founded by Her Holiness Shri Mataji Nirmala Devi
            in 1970. Unlike other practices, Sahaja Yoga allows spontaneous awakening of the dormant spiritual
            energy called Kundalini. When awakened, it brings about a state of mental silence, inner peace,
            and balanced awareness.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6 text-left">
            It is not just a technique — it's a breakthrough in human evolution, empowering individuals to heal
            themselves emotionally, physically, and spiritually. And best of all, it's always free.
          </p>
          <div className="text-center lg:text-left">
            <button
              onClick={handleScrollToSession}
              className="bg-green-700 text-white font-medium px-6 py-3 rounded-full hover:bg-green-800 transition"
            >
              Try a Free Session
            </button>
          </div>
        </div>
      </div>

      {/* Explanation Section */}
      <div className="max-w-4xl mx-auto mt-20 space-y-5 px-1 sm:px-0">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center">
          How is Sahaja Yoga different from other types of meditation?
        </h2>
        <p className="text-gray-700 leading-relaxed text-left">
          The method of Sahaja Yoga is unique: Through the experience of Kundalini awakening, the process of going into
          thoughtless awareness is completely spontaneous and does not require any kind of mental control.
        </p>
        <p className="text-gray-700 leading-relaxed text-left">
          It is this state of thoughtless awareness that sets Sahaja Yoga apart. It’s a transformative state which increases
          our ability to feel joy and peace within.
        </p>
        <p className="text-gray-700 leading-relaxed text-left">
          Sahaja Yoga empowers you to become the master of your own growth. There are no levels, qualifications, or hierarchies.
          All sessions are free and voluntarily run.
        </p>
      </div>

      {/* Scroll Target + Donation */}
      <div ref={sessionRef} className="max-w-5xl mx-auto mt-24">
        <DonationCallout />
      </div>
    </section>
  );
};

export default MeditationPage;
